.page {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.container {
  max-width: 100%;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.projectImage {
  height: 2.4rem;
  width: 3.6rem;
  min-width: 3.6rem;
  flex: 1;
  object-fit: cover;
  border-radius: 0.4rem;
}
